module.exports = __webpack_public_path__ + "static/media/1267.09b4e711.jpg";